import React, { useEffect, useRef, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";

/**
 * Timeline card component
 * @param index number of card
 * @param journey journey object
 * @returns Timeline card component with date, content and image
 */
const TimelineCard = ({ index, journey }) => {
    const journeyRef = useRef();
    const [ animation, setAnimation ] = useState("before-animation");

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if(index % 2) {
                    setAnimation("animate-slide-in-from-left");
                }else{
                    setAnimation("animate-slide-in-from-right");
                }

            observer.unobserve(journeyRef.current);
            }
        }, { rootMargin: "0px 0px 10% 0px" });
        observer.observe(journeyRef.current);
        
        return () => observer.disconnect();
    });

    return(
        <div ref={ journeyRef } className={`${ index % 2 ? "b-corp-timeline-left" : "b-corp-timeline-right" } b-corp-timeline`}>
            { index % 2 ? null : <div className=""></div> }
            <div className={`b-corp-timeline-card ${animation}`}>
                <GatsbyImage draggable={ false } className="lazyload b-corp-timeline-image" image={ journey.bCorpJourneyRepeaterImage.localFile.childImageSharp.gatsbyImageData } alt="" />
                <div className="b-corp-timeline-card-date" dangerouslySetInnerHTML={{ __html: journey.bCorpJourneyRepeaterDate }} />
                <div className="b-corp-timeline-card-content" dangerouslySetInnerHTML={{ __html: journey.bCorpJourneyRepeaterContent }} />
            </div>
            { index % 2 ? <div className=""></div> : null }
        </div>
    )
}

/**
 * Timeline component
 * @param bCorpFields bCorpFields object
 * @returns Timeline component with a many time line cards
 */
const Timeline = ({ bCorpFields }) =>  {

    return(
        <div className="body_layout">
            <h2 className="h-large h-faded">b corp journey.</h2>
            <div className="b-corp-timeline-layout">
                <div className="b-corp-timeline-wrapper">
                    { bCorpFields.bCorpJourneyRepeater && bCorpFields.bCorpJourneyRepeater.map(( journey, index ) => {
                        return(
                            <TimelineCard key={`b-corp-timeline-card-${index}`} index={ index } journey={ journey } />
                        )
                    })}
                </div> 
            </div>
            { bCorpFields.bCorpPending ?
                <div className="b-corp-timeline-loading">
                    <h3 className="b-corp-timeline-loading-title h-med">
                        b corp <span className="b-corp-timeline-loading-title-span">pending.</span>
                    </h3>
                    <svg viewBox="0 -50 1860 130">
                        <rect x="400" width="800" height="35" fill="white" />
                        <rect x="1200" y="1" width="250" height="34" fill="none" stroke="white" strokeWidth="1px" strokeMiterlimit="10" />
                    </svg>
                </div>
            :
                null
            }
        </div>
    )
}

export default Timeline;